import {FormGroup, FormLabel} from "react-bootstrap";
import {useEffect, useState} from "react";

import GenericCombobox from "@/components/ui/combo-box/combo-box.jsx";
import AnimatedComponents from "../ui/animated-component/animated-components.jsx";
import PropTypes from "prop-types";

export function LiveFormSearch({setSearchTerm}) {
  const [searchHistory, setSearchHistory] = useState([]);
  
  useEffect(() => {
    const history = JSON.parse(localStorage.getItem('mobilidade-app-search-history')) || [];
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setSearchHistory(history.map(term => ({name: term})));
  }, []);
  
  return (
    <AnimatedComponents>
      <FormGroup>
        <FormLabel column={"lg"} className={"w-100"}>
          <GenericCombobox
            items={searchHistory}
            itemToString={(item) => (item ? item.name : '')}
            onSelectedItemChange={(item) => setSearchTerm(item ? item.name : '')}
            label="Pesquisas recentes"
            placeholder="Selecione uma pesquisa recente"
            required={false}
          />
        </FormLabel>
      </FormGroup>
    </AnimatedComponents>
  )
}

export function LiveFormLines({lines, setLineSelected}) {
  return (
    <div className={"d-none"}>
      <AnimatedComponents>
        <FormGroup>
          <FormLabel column={"lg"} className={"w-100"}>
            <GenericCombobox
              items={lines}
              itemToString={(item) => (item ? item.name : '')}
              onSelectedItemChange={setLineSelected}
              label="Linha"
              placeholder="Selecione uma linha"
              required={false}
            />
          </FormLabel>
        </FormGroup>
      </AnimatedComponents>
    </div>
  )
}

export function LiveFormDeparturePoints({departurePoints, setDeparturePointSelected}) {
  return (
    <AnimatedComponents>
      <FormGroup>
        <FormLabel column={"lg"} className={"w-100"}>
          <GenericCombobox
            items={departurePoints}
            itemToString={(item) => (item ? item.name : '')}
            onSelectedItemChange={setDeparturePointSelected}
            label="Ponto de parada"
            placeholder="Selecione um ponto"
            required={true}
          />
        </FormLabel>
      </FormGroup>
    </AnimatedComponents>
  )
}

LiveFormSearch.propTypes = {
  setSearchTerm: PropTypes.func.isRequired
}

LiveFormLines.propTypes = {
  lines: PropTypes.array.isRequired,
  setLineSelected: PropTypes.func.isRequired
}

LiveFormDeparturePoints.propTypes = {
  departurePoints: PropTypes.array.isRequired,
  setDeparturePointSelected: PropTypes.func.isRequired
}
